const notificationTypeLabels = {
  general: "عام",
  contractor: "طلب تسجيل مقاول",
  supplier: "طلب تسجيل مورد",
  userPriceQuotation: "طلب عرض سعر من عميل",
  contractorAcceptedQuotation: "قبول طلب من مقاول",
  contractorPriceQuotation: "عرض سعر جديد من مقاول",
  userChosenContractor: "اختيار مقاول",
  userRejectedContractor: "رفض مقاول",
  userSupplierPriceQuotation: "طلب توريد جديد",
  supplierAcceptedQuotation: "قبول طلب من مورد",
  supplierSubmittedQuotation: "عرض سعر جديد من مورد",
  userChosenSupplier: "اختيار مورد",
  userRejectedSupplier: "رفض مورد",
  userInvoiceRequest: "طلب فاتورة",
  supplierInvoiceSent: "فاتورة من مورد",
  supportMessage: "رسالة دعم",
  chat: "رسالة محادثة",
  paymentRequest: "طلب دفع",
};

const titleLabels = {
  "Supplier profile file change request": "طلب تغيير ملف المورد",
  "Commercial register change request": "طلب تغيير السجل التجاري",
  "Accepted change request": "قبول طلب تغيير",
  "Rejected change request": "رفض طلب تغيير",
};

const typeRoutes = {
  contractor: "/admin/register-requests",
  supplier: "/admin/supplier-register-requests",
  paymentRequest: "/admin/payments",
  supportMessage: "/admin/complaints",
  userPriceQuotation: "/admin/orders",
  contractorAcceptedQuotation: "/admin/orders",
  contractorPriceQuotation: "/admin/orders",
  userChosenContractor: "/admin/orders",
  userRejectedContractor: "/admin/orders",
  userSupplierPriceQuotation: "/admin/supplier-quotations",
  supplierAcceptedQuotation: "/admin/supplier-quotations",
  supplierSubmittedQuotation: "/admin/supplier-quotations",
  userChosenSupplier: "/admin/supplier-quotations",
  userRejectedSupplier: "/admin/supplier-quotations",
  userInvoiceRequest: "/admin/supplier-quotations",
  supplierInvoiceSent: "/admin/supplier-quotations",
  chat: "/admin/complaints",
};

const textReplacements = [
  ["Supplier profile file change request from", "طلب تغيير ملف المورد من"],
  ["Commercial register change request from", "طلب تغيير السجل التجاري من"],
  ["Accepted supplierProfilePdf request for", "تم قبول طلب تغيير ملف المورد لـ"],
  ["Accepted commercialRegister request for", "تم قبول طلب تغيير السجل التجاري لـ"],
  ["Rejected supplierProfilePdf request for", "تم رفض طلب تغيير ملف المورد لـ"],
  ["Rejected commercialRegister request for", "تم رفض طلب تغيير السجل التجاري لـ"],
  ["Accepted change request", "قبول طلب تغيير"],
  ["Rejected change request", "رفض طلب تغيير"],
  ["Phone:", "الهاتف:"],
  ["New profile file:", "ملف المورد الجديد:"],
  ["New commercial register:", "السجل التجاري الجديد:"],
  ["Expiration date:", "تاريخ الانتهاء:"],
  ["Membership number:", "رقم العضوية:"],
];

const changeRequestTitles = new Set([
  "Supplier profile file change request",
  "Commercial register change request",
  "Accepted change request",
  "Rejected change request",
]);

const includesAny = (text, values) =>
  values.some((value) => text && text.includes(value));

export const getNotificationTypeLabel = (type) =>
  notificationTypeLabels[type] || type || "غير محدد";

export const getNotificationTitle = (notification) => {
  const title = notification?.title || "";
  return titleLabels[title] || title || "بدون عنوان";
};

export const getNotificationBody = (notification) => {
  const body = notification?.body || "";
  return textReplacements.reduce(
    (current, [from, to]) => current.replaceAll(from, to),
    body
  );
};

export const getNotificationRoute = (notification) => {
  const type = notification?.notificationType;
  const title = notification?.title || "";
  const body = notification?.body || "";

  if (typeRoutes[type]) return typeRoutes[type];

  if (changeRequestTitles.has(title)) {
    return "/admin/commercial-register-change-requests";
  }

  if (
    includesAny(title, ["عرض جديد", "قبول عرض", "رفض عرض"]) ||
    includesAny(body, ["عرض جديد", "قبول عرض", "رفض عرض"])
  ) {
    return "/admin/offers";
  }

  if (
    includesAny(title, ["إضافة عميل جديد"]) ||
    includesAny(body, ["إضافة عميل جديد"])
  ) {
    return "/admin/users";
  }

  return "/admin/notifications";
};
